import { SmoothScroll } from "@/components/SmoothScroll";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { BrandMarquee } from "@/components/BrandMarquee";
import { About } from "@/components/About";
import { Services } from "@/components/Services";
import { Gallery } from "@/components/Gallery";
import { EnquiryBuilder } from "@/components/EnquiryBuilder";
import { Reviews } from "@/components/Reviews";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

const IMAGES = {
  aircon: "https://images.pexels.com/photos/38788452/pexels-photo-38788452.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  electrical: "https://images.unsplash.com/photo-1759262151046-b91fa96e4006?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export default function MarketingSite() {
  return (
    <div className="grain min-h-screen bg-cloud">
      <SmoothScroll>
        <Header />
        <main>
          <Hero imageUrl={IMAGES.aircon} />
          <BrandMarquee />
          <About imageUrl={IMAGES.electrical} />
          <Services />
          <Gallery />
          <EnquiryBuilder imageUrl={IMAGES.aircon} />
          <Reviews />
          <Contact />
        </main>
        <Footer />
      </SmoothScroll>
    </div>
  );
}
